(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[553],{

/***/ 7854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _var_www_vhosts_weprofit_global_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(683);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(981);
/* harmony import */ var components_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);

var _excluded = ["pages", "selectedLang", "pageParams"];

 //* Component




var Imprint = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (_ref) {
  var pages = _ref.pages,
      selectedLang = _ref.selectedLang,
      pageParams = _ref.pageParams,
      props = (0,_var_www_vhosts_weprofit_global_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var imprintsFakeData = {
    title: 'Imprints',
    firstSection: [{
      title: 'Responsible according to § 5 Telemedia Act (TMG)',
      compName: 'WeProfit GmbH',
      compAddress: 'Platz der Einheit 2, 60327 Frankfurt am Main',
      compMobile: 'Mobile: +49 (0) 174/204 8888',
      compEmail: 'Email: contact@weprofit.global',
      compWeb: 'Web: www.weprofit.global',
      compRegCourt: 'Register court: District court Frankfurt am Main',
      compHRBNum: 'HRB number: 112834 VAT ID: DE337510412',
      compAuthorized: 'Authorized representative: Arsen Abrahamyan'
    }],
    secondSection: [{
      title: 'Responsible for editorial content according to § 55 paragraph 2 of the Interstate Broadcasting Treaty',
      compAuthorized: 'Arsen Abrahamyan',
      compName: 'WeProfit GmbH',
      compAddress: 'Platz der Einheit 2, 60327 Frankfurt am Main',
      compMobile: 'Mobile: +49 (0) 174/204 8888'
    }],
    lastSection: [{
      title: 'Notice according to § 36 VSBG',
      desc: 'The European Commission provides a platform for online dispute resolution (OS), which you can find here http://ec.europa.eu/consumers/odr/.We are neither obliged nor willing to participate in a dispute settlement procedure before a consumer arbitration board.Photo credits / rights holders'
    }]
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    className: "imprint",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .ImprintPage */ .mP, {
      imprintsFakeData: imprintsFakeData
    })
  });
});
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withUIContext */ .pP)((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withDataContext */ .hX)(Imprint, ['pages'])));

/***/ }),

/***/ 3643:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imprint",
      function () {
        return __webpack_require__(7854);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,188,774,888,179], function() { return __webpack_exec__(3643); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);